import React from 'react';

class TabHeader extends React.Component {

  constructor(props) {
    super(props);
  }
  render() {
    if(!!this.props.data) {
      return (
      <li onClick={this.props.onClick} className={"tab" + (!!this.props.isSelected ? " selected" : "")}>{ this.props.data.title }
          <div className='content'>{this.props.element}</div>
      </li>)
    }
    return (
      ""
    )
  }
}

export default TabHeader;